import { createContext, useContext } from 'react'
import { PORTRAIT_GAME_TOP_BAR_HEIGHT } from '../lib/gameChrome'

/** The measured live header survives switching to a snapshot. */
export const GameMapChromeContext = createContext(PORTRAIT_GAME_TOP_BAR_HEIGHT)
export function useGameMapChromeHeight() { return useContext(GameMapChromeContext) }

export interface PortraitMapFit { mapId: string; scale: number; shift: number; tipsHeight: number }
export const IDENTITY_MAP_FIT: PortraitMapFit = { mapId: '', scale: 1, shift: 0, tipsHeight: 0 }
export const PortraitMapFitContext = createContext({
  fit: IDENTITY_MAP_FIT,
  recordFit: (_fit: PortraitMapFit) => {},
})
export function usePortraitMapFit(mapId: string) {
  const context = useContext(PortraitMapFitContext)
  return { ...context, fit: context.fit.mapId === mapId ? context.fit : IDENTITY_MAP_FIT }
}
